import styled from "styled-components";

export const StyledError = styled.div`
  padding: 20vh 0;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #727272;
  position: fixed;
  top: 0;
  background: white;
  z-index: 2000;
  left: 0;
  right: 0;

  pre {
    width: 100vw;
    white-space: break-spaces;
    padding: 20px;
    color: #727272;
  }

  .btn {
    background: ${(p) => p.theme.colors.primary};
    padding: 21px;
    color: white;
    font-weight: bold;
    border-radius: 4px;
    margin: auto;
    margin: 0 auto;
    max-width: 321px;
    min-width: 266px;
    width: 80vw;
    cursor: pointer;

    &:hover {
      background-color: #cd8b3f;
      color: white;
    }
  }

  .text {
    margin: auto;
    margin-top: 10vh;
    font-size: 18px;
    font-weight: normal;
    margin-bottom: 0;
  }

  .email {
    margin-top: 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0;
    color: ${(p) => p.theme.colors.primary};
  }
`;
